import { defineStore } from "pinia"
import { useBrowserLocation, useScrollLock } from "@vueuse/core";
import { ref, watch } from "vue";
import { deepdives, prefix, type Deepdive } from "../lib/deepdives";

export const useDeepdivesStore = defineStore('deepdives', () => {

  const location = useBrowserLocation()
  const documentScrollIsLocked = typeof document !== 'undefined' && useScrollLock(document)

  const active = ref<undefined | Deepdive>(undefined)

  // side effects
  watch(active, a => {
    if(documentScrollIsLocked) documentScrollIsLocked.value = a ? true : false
  }, { immediate: true })

  // swr value on second tick to trigger animation
  setTimeout(() => {

    watch(location, l => {
      active.value = getDeepdiveKeyFromHash(l.hash)
    }, { immediate: true })

  }, 0)
  
  function getDeepdiveKeyFromHash(hash?: string | undefined): (undefined | Deepdive) {
    
    // clean hash
    const h = hash?.replace('#', '')
  
    // if hash doesn't include the prefix
    if(!h || !h.startsWith(prefix)) return undefined
  
    // hash includes prefix, check if given popup exists, then do the assignment
    const deepdiveNameInHash = h.replace(prefix, '')

    for(const deepdiveKey in deepdives) {

      const deepdive = deepdives[deepdiveKey as keyof typeof deepdives]

      if(deepdive && deepdive.path === deepdiveNameInHash) return deepdives[deepdiveKey]

    }

    return undefined
  
  }

  function open(name: string )  {
    location.value.hash = '#' + prefix + name
  }

  function close() {

    // this causes scroll to top as a side effect
    // location.value.hash = ''

    // this avoids scroll to top
    active.value = undefined
    history.pushState("", document.title, window.location.pathname + window.location.search);
  }

  
  return { 
    active, 
    open, 
    close,
    deepdives
  }

})

// TODO: on activate pull header up.